function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill:#FFFFFF;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2_00000016038314312457471340000014885097141238633380_"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2"
}, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M588.7,296.4c0,163.7-131.8,296.3-294.3,296.3S0,460,0,296.4S131.8,0,294.3,0S588.7,132.7,588.7,296.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M911.6,296.4c0,154.1-65.9,279-147.2,279s-147.2-124.9-147.2-279s65.9-279,147.2-279S911.5,142.3,911.6,296.4 "
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M1043.6,296.4c0,138-23.2,249.9-51.8,249.9s-51.8-111.9-51.8-249.9s23.2-249.9,51.8-249.9 S1043.6,158.3,1043.6,296.4"
})));

function SvgMediumSymbolWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1043.6 592.7",
    style: {
      enableBackground: "new 0 0 1043.6 592.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumSymbolWhite);
export default __webpack_public_path__ + "static/media/Medium_Symbol_White.4fc7ad57.svg";
export { ForwardRef as ReactComponent };